import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const salePageSlice = createSlice({
    name: "salePageSlice",
    initialState,
    reducers: {
        setSalePageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setSaleCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setSaleTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setSaleTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetSalePagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setSalePageLimit,
    setSaleCurrentPage,
    setSaleTotalCount,
    setSaleTotalPages,
    resetSalePagination,
} = salePageSlice.actions;

export default salePageSlice.reducer;
